export const mindboxConfig = {
  enabled: true, // ms3-blocks
  endpointId: "gk-osnova.Website",
  pointOfContact: "zk-mainstreet.ru",
  brand: "gk-osnova",
  subscriptionPointOfContact: "Sms",
  disableTracker: true, // popup-with-chats
};

function normalizePhone(raw) {
  let d = String(raw || "").replace(/\D/g, "");
  if (d.length === 11 && d[0] === "8") d = "7" + d.slice(1);
  if (d.length === 10) d = "7" + d;
  return /^7\d{10}$/.test(d) ? d : "";
}

export function subscribeInFooter({ phone, email, isSubscribed = false } = {}) {
  if (typeof window.mindbox !== "function") return;
  const mobilePhone = normalizePhone(phone);
  if (!mobilePhone) return;

  const subscriptions = [];
  const isSubscribedBool = Boolean(isSubscribed);
  const emailTrim = email?.trim();

  const subscriptionSmsObject = {
    brand: mindboxConfig.brand,
    pointOfContact: mindboxConfig.subscriptionPointOfContact,
    isSubscribed: isSubscribedBool,
  };

  const subscriptionEmailObject = {
    brand: mindboxConfig.brand,
    pointOfContact: "Email",
    isSubscribed: Boolean(emailTrim),
  };

  if (!isSubscribedBool) {
    subscriptions;
  } else {
    if (emailTrim) {
      subscriptions.push(subscriptionSmsObject, subscriptionEmailObject);
    } else {
      subscriptions.push(subscriptionSmsObject);
    }
  }

  window.mindbox("async", {
    operation: "Website.SubscriptionInFooter",
    data: {
      pointOfContact: mindboxConfig.pointOfContact,
      customer: {
        mobilePhone,
        ...(email?.trim() ? { email: email.trim() } : {}),
        ...(subscriptions.length > 0 ? { subscriptions } : {}),
      },
    },
    onSuccess: () => console.log("[mindbox SUCCES] SubscriptionInFooter"),
    onError: (e) => console.error("[mindbox ERROR] SubscriptionInFooter", e),
  });
}

export function viewProduct(productId) {
  if (typeof window.mindbox !== "function" || !productId) return;

  const data = {
    viewProduct: {
      product: { ids: { website: String(productId) } },
    },
  };

  window.mindbox("async", {
    operation: "Website.ViewProduct",
    data,
    onSuccess: () => console.log("[mindbox SUCCES] ViewProduct"),
    onError: (e) => console.error("[mindbox ERROR] ViewProduct", e),
  });
}